require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-groundbreaking-of-the-seren-row-site-was-commemorated.json") })
        }
      }, "path---news-the-groundbreaking-of-the-seren-row-site-was-commemorated");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-groundbreaking-of-the-seren-row-site-was-commemorated!./.cache/json/news-the-groundbreaking-of-the-seren-row-site-was-commemorated.json
// module id = 851
// module chunks = 231608221292675